import { createSlice } from '@reduxjs/toolkit';

interface IState {
  ipData: any;
}

const initialState: IState = {
  ipData: {},
};

const webTrackingSlice = createSlice({
  name: 'user',
  initialState: initialState,
  reducers: {
    setIpData: (state, action) => {
      state.ipData = action.payload;
    },
  },
});

export const { setIpData } = webTrackingSlice.actions;

export default webTrackingSlice.reducer;
